import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getImageGalleries } from "../../api/api";
import { Gallery } from "../../types/gallery";
import { Container, Row, Col, Card } from "react-bootstrap";

const ImageGallery = () => {
  const { i18n } = useTranslation();


  const { isLoading, data }: any = useQuery("ImageGalleriesData", () =>
    getImageGalleries({
      language: i18n.language,
    })
  );

  if (isLoading) return <div></div>;

  return (
    <BootstrapContainer>
      <Row>
        {data.data.map((item: Gallery) => (
          <Col md={4} key={item.id}>
            <Link to={`/gallery/${item.id}`} style={{ textDecoration: 'none' }}>
              <StyledCard className="mb-4 shadow">
                <CardImage src={`${process.env.REACT_APP_CMS}${item?.attributes.images?.data?.[0]?.attributes?.url ?? ''}`} />
                <Card.Body>
                  <Card.Title>{item.attributes.title}</Card.Title>
                </Card.Body>
              </StyledCard>
            </Link>
          </Col>
        ))}
      </Row>
    </BootstrapContainer>
  );
};

const BootstrapContainer = styled(Container)`
  padding-top: 20px;
`;

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 400px; // Fixed height for the entire card
`;

const CardImage = styled(Card.Img)`
  height: 250px; // Fixed height for the image
  object-fit: cover; // Ensures the image covers the area without distorting
`;

export default ImageGallery;
